import EmailVerificationForm from '../../components/userSettings/emailVerificationForm';
import OTPVerificationForm from '../../components/userSettings/OTPVerificationForm';
import ResetPasswordForm from '../../components/userSettings/resetPasswordForm';
import { passwordResetStages } from '../../common/constants/passwordResetStages';

/**
 * Renders the appropriate form based on the password reset stage
 * @param {string} stage - Current stage of the password reset process (from passwordResetStages)
 * @param {object} forms
 * @param {object} loading
 * @param {object} handlers
 * @param {function} t - Translation function
 * @returns {JSX.Element} - The appropriate form component
 */
export const renderResetPasswordContent = ({ stage, forms, loading, handlers, t, resetEmail }) => {
    switch (stage) {
        case passwordResetStages.EMAIL:
            return (
                <EmailVerificationForm
                    form={forms.emailForm}
                    loading={loading.email}
                    onSubmit={handlers.handleEmailSubmit}
                    t={t}
                    resetEmail={resetEmail}
                />
            );
        case passwordResetStages.OTP:
            return (
                <OTPVerificationForm
                    form={forms.otpForm}
                    loading={loading.otp}
                    onSubmit={handlers.handleOtpSubmit}
                    onBack={handlers.handleResetBack}
                    t={t}
                />
            );
        case passwordResetStages.RESET:
            return (
                <ResetPasswordForm
                    form={forms.passwordForm}
                    setLoading={handlers.setLoading}
                    loading={loading.resetPassword}
                    onBack={handlers.handleResetBack}
                    t={t}
                />
            );
        default:
            return null;
    }
};
